<template>
    <div class="filters mt-2 d-flex align-items-end justify-content-between">
        <div class="mb-0 text-uppercase">Sort by <span @click="toggleSortOrder()" class="color-secondary cursor-pointer">{{ sortByComputed }}</span></div>
        <div class="btn-group">
            <button type="button" class="btn btn-transparent p-0 d-flex align-items-center dropdown-toggle text-uppercase" :class="{'show-tick' : filterValuesComputed.length}" data-toggle="dropdown" aria-expanded="false">
                Filter
            </button>

            <div class="dropdown-menu dropdown-menu-right ingredients-dropdown p-2" v-if="ingredientsList.length">
                <div v-for="(ingredient, index) in ingredientsList" :key="index" class="custom-tick">
                    <div class="form-check mt-2">
                        <input @change="filterDocuments()" class="form-check-input" :name="ingredient" type="checkbox" :value="ingredient" :id="ingredient" v-model="filterValuesComputed">
                    
                        <label :for="ingredient" class="form-check-label">
                            {{ ingredient }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import FilterMixin from '@/mixins/FilterMixin'
export default {
    name: 'FilterComponent',

    mixins: [
        FilterMixin
    ],

    computed: {
        ...mapGetters({
            documents: 'DocumentStore/getDocuments',
            ingredientsList: 'DocumentStore/getIngredientsList',
            filterValues: 'DocumentStore/getFilterValues',
            sortOrder: 'DocumentStore/getSortOrder'
        }),

        filterValuesComputed: {
            get: function() {
                return this.filterValues
            }, 

            set: function(val) {
                this.setFilterValues(val)
            }
        },

        sortByComputed: {
            get: function() {
                if(this.sortOrder === 1) {
                    return 'a-z'
                }

                return 'z-a'
            }
        }
    },

    methods: {
        ...mapActions({
            setSortOrder: 'DocumentStore/setSortOrder',
            setFilterValuesAction: 'DocumentStore/setFilterValues'
        }),

        async setFilterValues(val) {
            await this.setFilterValuesAction(val)

            await this.filterDocuments()
        },

        async toggleSortOrder() {
            if(parseInt(this.sortOrder) === 1) {
                await this.setSortOrder(2)
                await this.filterDocuments()
            } else {
                await this.setSortOrder(1)
                await this.filterDocuments()
            }
        }
    }
}
</script>